import React from 'react';
import { compose } from 'redux';

import {
  cloneDeep, orderBy
} from 'lodash';


import * as Table from 'reactabular-table';
import * as search from 'searchtabular';
import * as sort from 'sortabular';
import * as resolve from 'table-resolver';

import { Row, Col, Panel } from 'react-bootstrap';

import VisibilityToggles from 'react-visibility-toggles';

import {
  Paginator, PrimaryControls, paginate
} from '../tableHelpers';

import { generateStateColumn } from 'utils/analyseState';

var elevator = require('../../../static/img/elevator.png')
var escalator = require('../../../static/img/escalator.png')

import _ from 'underscore'
require('./productTable.css')

var MobileDetect = require('mobile-detect');
import { translate } from 'react-i18next';


@translate(['common'])
export default class ComProductList extends React.Component {
  constructor(props) {
    super(props);
    var rows = this.props.products ? this.props.products : [];
    var cols = this.getColumns(props)
    this.state = {
      rows: this.props.products, // initial rows
      searchColumn: 'all',
      query: {}, // search query
      sortingColumns: null, // reference to the sorting columns
      columns: cols, // initial columns
      initialCols: cols,
      pagination: { // initial pagination settings
        page: 1,
        perPage: 10
      },
      isPhone: false
    };

    this.onRow = this.onRow.bind(this);
    this.onRowSelected = this.onRowSelected.bind(this);
    this.onColumnChange = this.onColumnChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onPerPage = this.onPerPage.bind(this);
    this.onToggleColumn = this.onToggleColumn.bind(this);
    this.showHistory = this.showHistory.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  showHistory(id) {

    var display = document.getElementById(id).style.display

    if (display == 'block') {
      document.getElementById(id).style.display = 'none'
    } else {
      document.getElementById(id).style.display = 'block'
    }

  }


  updateDimensions() {
    var md = new MobileDetect(window.navigator.userAgent);


    if (md.tablet() || md.phone()) {
      var cols = this.state.columns;

      cols = cols.map((c) => {
        if (['etat', 'identification_NUM_ASC', 'actions', 'identification_GSM'].indexOf(c.property) > -1) {
          return { ...c, visible: true }
        } else {
          return { ...c, visible: false }

        }
      })

      if (this.state.isPhone == false) {
        this.setState({ columns: cols, expanded: false, isPhone: true })
      }


    } else {

      if (this.state.isPhone == true) {
        this.setState({ columns: this.state.initialCols, expanded: true, isPhone: false })
      }
    }

  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
    this.updateDimensions()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.products !== this.props.products) {
      this.setState({ rows: this.props.products })
      this.updateDimensions();
    }
  }


  getColumns(props) {

    var self = this;

    const {t} = props

    var not_provided = t('not_provided')

    const sortable = sort.sort({
      getSortingColumns: () => this.state.sortingColumns || [],
      onSort: selectedColumn => {
        this.setState({
          sortingColumns: sort.byColumns({
            sortingColumns: this.state.sortingColumns,
            selectedColumn
          })
        });
      }
    });

    const sortableHeader = sortHeader(sortable, () => this.state.sortingColumns);


    var columns = [

      {
        property: 'addr_id',
        header: {
          label: 'addr_id',
          props: {
            className: "col-md-1"
          }
        },
        visible: false
      },

      {
        header: {
          label: t('main.type'),
          formatters: [sortableHeader],
          props: {
            className: "col-md-1"
          }
        },
        cell: {
          formatters: [
            (value, { rowData }) => {

              if (rowData.identification_type == 'ASC' || rowData.identification_type == 'ASC-IP') {
                var picto = elevator
                var pictoTitle = rowData.identification_type == 'ASC-IP' ? "Ascenseur CAN-IP" : t("main.lift")
              } else if (rowData.identification_type == 'EM') {
                var picto = escalator
                var pictoTitle = t("main.mecanic_stairs")
              } else {
                var picto = false
              }

              if (picto) {
                return (<span><img title={pictoTitle} width="50" src={picto} /></span>)
              } else {
                return <span />
              }

            }
          ]
        },
        visible: true
      },



      {
        property: 'etat',
        header: {
          label: t('main.state'),
          formatters: [sortableHeader],
          props: {
            className: "col-md-1"
          }
        },


        cell: {
          formatters: [
            (value, { rowData }) => {
              return (<span>{generateStateColumn(rowData)}</span>)

            }
          ]
        },
        visible: true
      },


      {
        property: 'identification_NUM_ASC',
        header: {
          label:  t('main.install_num'),
          formatters: [sortableHeader],
          props: {
            className: "col-md-1"
          }
        },
        cell: {
          formatters: [(value, { rowData }) => {
            return !value ? not_provided : value

          }, search.highlightCell


          ]
        },

        visible: true
      },


      {
        property: 'identification_ID',
        header: {
          label:  t('main.identity'),
          formatters: [sortableHeader],
          props: {
            className: "col-md-1"
          }
        },
        cell: {
          formatters: [(value, { rowData }) => {
            return !value ? not_provided : value

          }, search.highlightCell


          ]
        },
        visible: true
      },
      {
        property: 'localisation_adresse',
        header: {
          label: t('main.address'),
          formatters: [sortableHeader],
          props: {
            className: "col-md-3"
          }
        },
        cell: {
          formatters: [(value, { rowData }) => {
            return !value ? not_provided : value

          }, search.highlightCell


          ]
        },
        visible: true
      },

      {
        property: 'localisation_ville',
        header: {
          label: t('main.city'),
          formatters: [sortableHeader],
          props: {
            className: "col-md-3"
          }
        },
        cell: {
          formatters: [(value, { rowData }) => {
            return !value ? not_provided : value

          }, search.highlightCell


          ]
        },
      },

      {
        property: 'localisation_prestataire',
        header: {
          label: t('main.prestataire'),
          formatters: [sortableHeader],
          props: {
            className: "col-md-1"
          }
        },
        cell: {
          formatters: [(value, { rowData }) => {
            return !value ? not_provided : value

          }, search.highlightCell


          ]
        },
        visible: true
      },

      {
        property: 'identification_GSM',
        header: {
          label: t("main.gsm_number"),
          formatters: [sortableHeader],
          props: {
            className: "col-md-1"
          }
        },
        cell: {
          formatters: [(value, { rowData }) => {
            return !value ? not_provided : value

          }, search.highlightCell


          ]
        },
        visible: true
      },

      {
        property: 'identification_NUM_MOD',
        header: {
          label: t("main.num_module"),
          formatters: [sortableHeader],
          props: {
            className: "col-md-1"
          }
        },
        cell: {
          formatters: [search.highlightCell]
        },
        visible: true
      }
    ];



    return columns;


  }
  render() {
    const {t} = this.props
    const {
      columns, rows, pagination, sortingColumns, searchColumn, query
    } = this.state;

    const cols = columns.filter(column => column.visible);

    var newRows = rows.filter((r) => {
      return (r.identification_fosse < 1 || r.identification_fosse == null)
    })


    const paginated = compose(
      paginate(pagination),
      sort.sorter({ columns: cols, sortingColumns, sort: orderBy }),
      search.highlighter({ columns: cols, matches: search.matches, query }),
      search.multipleColumns({ columns: cols, query }),
      resolve.resolve({
        columns: cols,
        method: ({ rowData, column }) => resolve.byFunction('cell.resolve')({
          rowData: resolve.nested({ rowData, column }),
          column
        })
      })
    )(newRows);


    return (
      <div>
        {/*<VisibilityToggles
          columns={columns}
          onToggleColumn={this.onToggleColumn}
        />*/}

        <Row>
          <Col xs={12} md={6}>
            <Panel collapsible header="Affichage">
              <VisibilityToggles
                columns={columns}
                onToggleColumn={this.onToggleColumn}
              />
            </Panel>
          </Col>
        </Row>

        <PrimaryControls
          className="controls"
          perPage={pagination.perPage}
          column={searchColumn}
          query={query}
          columns={this.getColumns(this.props)}
          rows={rows}
          onPerPage={this.onPerPage}
          onColumnChange={this.onColumnChange}
          onSearch={this.onSearch}
          t={t}
        />

        <div className="table-responsive">
          <Table.Provider
            className="table table-striped"
            columns={this.getColumns(this.props)}
            style={{ overflowX: 'auto' }}
            ref="table"
          >
            <Table.Header>
              <search.Columns query={query} columns={this.getColumns(this.props)} onChange={this.onSearch} />
            </Table.Header>

            <Table.Body onRow={this.onRow} rows={paginated.rows} rowKey="id" />

          </Table.Provider>

        </div>

        <div className="controls">
          <Paginator
            pagination={pagination}
            pages={paginated.amount}
            onSelect={this.onSelect}
            prevText={t("pagination.previous")}
            nextText={t("pagination.next")}
          />
        </div>
      </div>
    );
  }
  onRow(row, { rowIndex }) {
    return {
      onClick: () => this.onRowSelected(row)
    };
  }
  onRowSelected(row) {
  }
  onColumnChange(searchColumn) {
    this.setState({
      searchColumn
    });
  }
  onSearch(query) {
    this.setState({
      query
    });
  }
  onSelect(page) {
    const pages = Math.ceil(
      this.state.rows.length / this.state.pagination.perPage
    );

    this.setState({
      pagination: {
        ...this.state.pagination,
        page: Math.min(Math.max(page, 1), pages)
      }
    });
  }
  onPerPage(value) {
    this.setState({
      pagination: {
        ...this.state.pagination,
        perPage: parseInt(value, 10)
      }
    });
  }

  onToggleColumn(columnIndex) {
    const columns = cloneDeep(this.state.columns);
    const column = columns[columnIndex];
    column.visible = !column.visible;
    const query = cloneDeep(this.state.query);
    delete query[column.property];
    this.setState({ columns, query });
  }
}

const CustomFooter = ({ columns, rows }) => {
  return (
    <tfoot>
      <tr>
        {columns.map((column, i) =>
          <td key={`footer-${i}`}>{column.footer ? column.footer(rows) : null}</td>
        )}
      </tr>
    </tfoot>
  );
}

function sortHeader(sortable, getSortingColumns) {
  return (value, { columnIndex }) => {
    const sortingColumns = getSortingColumns() || [];

    return (
      <div style={{ display: 'inline' }}>
        <span className="value">{value}</span>
        {React.createElement(
          'span',
          sortable(
            value,
            {
              columnIndex
            },
            {
              style: { float: 'right' }
            }
          )
        )}
        {sortingColumns[columnIndex] &&
          <span className="sort-order" style={{ marginLeft: '0.5em', float: 'right' }}>
            {sortingColumns[columnIndex].position + 1}
          </span>
        }
      </div>
    );
  };
}




